import { IconProps } from 'interfaces';
import COLOR from 'constants/color';
import { isDarkMode } from 'utils/validators';

const Play = ({
  className = '~w-4/5 ~h-4/5',
  fill = COLOR.GRAY['900'],
  fillDarkMode = COLOR.WHITE
}: IconProps) => {
  const fillColor = isDarkMode() ? fillDarkMode : fill;
  return (
    <svg
      viewBox='0 0 26 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      preserveAspectRatio='xMidYMid meet'>
      <path
        d='M24.3356 3.62167C24.2069 3.10753 23.9448 2.63645 23.5758 2.25602C23.2068 1.87559 22.7439 1.59928 22.234 1.455C20.3706 1 12.9173 1 12.9173 1C12.9173 1 5.46395 1 3.60062 1.49833C3.09064 1.64262 2.62776 1.91893 2.25874 2.29936C1.88973 2.67979 1.62764 3.15086 1.49895 3.665C1.15794 5.55602 0.991125 7.47434 1.00062 9.39583C0.988464 11.3318 1.15528 13.2647 1.49895 15.17C1.64083 15.6682 1.90878 16.1213 2.27694 16.4857C2.6451 16.85 3.10101 17.1133 3.60062 17.25C5.46395 17.7483 12.9173 17.7483 12.9173 17.7483C12.9173 17.7483 20.3706 17.7483 22.234 17.25C22.7439 17.1057 23.2068 16.8294 23.5758 16.449C23.9448 16.0685 24.2069 15.5975 24.3356 15.0833C24.674 13.2066 24.8408 11.3029 24.834 9.39583C24.8461 7.45987 24.6793 5.52692 24.3356 3.62167Z'
        stroke={fillColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.4798 12.9383L16.709 9.39583L10.4798 5.85333V12.9383Z'
        stroke={fillColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Play;
